/* Sticky product gallery — float it mid-viewport instead of hugging the top.

   Vendor patch 13 (docs/vendor-patches.md) gives both product columns their
   header clearance in pure CSS. Centring the gallery needs the one number CSS
   cannot reach, the element's own height, so this measures it and publishes
   --jll-centre; the patch's max() rule keeps the clearance in charge of the
   result. The consumer sits inside @media (min-width: 750px), so nothing is
   written below it. */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 750px)');

  function galleries() {
    return document.querySelectorAll('.product__media-wrapper .product__column-sticky');
  }

  function update() {
    if (!DESKTOP.matches) return;
    galleries().forEach(function (g) {
      g.style.setProperty('--jll-centre', Math.floor((window.innerHeight - g.offsetHeight) / 2) + 'px');
    });
  }

  /* observe() delivers an initial callback, so this is also the first measure. */
  var observer = new ResizeObserver(update);
  function watch() { galleries().forEach(function (g) { observer.observe(g); }); }

  watch();
  window.addEventListener('resize', update);
  /* The theme editor re-renders the section with fresh elements. */
  document.addEventListener('shopify:section:load', watch);
})();
